import axios from "axios";

export default axios.create({
  baseURL: 'https://tldthreatpulse.shreshtait.com',
  // baseURL: 'http://139.5.190.116',
  withCredentials: true,
});